/** tm/todoDue.ts — 동행상담 결과 리포트 「해야할 일」 상위 줄 기한 = 하위 기한 묶음(2026-10-26)
 *  backend/services/todoDue.js 와 같은 규칙 — 편집 화면에서 리포트에 나갈 값을 미리 보여 준다. */
const OPEN = /^\s*(요청\s*시|미정|-)?\s*$/;
const PART: Record<string, number> = { 초: 0, 중: 1, 중순: 1, 말: 2 };

export const isOpenDue = (d: string | undefined) => OPEN.test(String(d || ''));

function ord(tok: string, y: number, mBase: number): number | null {
  const m = /^(?:(내년|\d{2,4})\s*년?\s*)?(\d{1,2})\s*월\s*(초|중순|중|말)?$/.exec(String(tok || '').trim());
  if (!m) return null;
  const mon = +m[2];
  if (mon < 1 || mon > 12) return null;
  const yr = m[1] === '내년' ? y + 1 : m[1] ? (m[1].length === 2 ? 2000 + +m[1] : +m[1]) : mon < mBase ? y + 1 : y;
  return ((yr - y) * 12 + (mon - mBase)) * 3 + (m[3] ? PART[m[3]] : 1);
}

/** 하위 기한들 → 상위에 쓸 기한 · 없으면 '' · date = 상담일(YYYY-MM-DD) */
export function spanOf(dues: string[], date?: string): string {
  const list = dues.map(d => String(d || '').trim()).filter(d => d && !OPEN.test(d));
  if (!list.length) return '';
  const s = String(date || '').slice(0, 10);
  const now = new Date();
  const y = /^\d{4}-\d{2}/.test(s) ? +s.slice(0, 4) : now.getFullYear();
  const mBase = /^\d{4}-\d{2}/.test(s) ? +s.slice(5, 7) : now.getMonth() + 1;
  const ends: [number, string][] = [];
  for (const d of list) {
    const [a, b] = d.split(/\s*[~～-]\s*/);
    const e = b === undefined ? a : b;
    const oa = ord(a, y, mBase), ob = ord(e, y, mBase);
    if (oa === null || ob === null) { const f = list[0], l = list[list.length - 1]; return f === l ? f : `${f} ~ ${l}`; }
    ends.push([oa, a.trim()], [ob, e.trim()]);
  }
  let lo = ends[0], hi = ends[0];
  for (const x of ends) { if (x[0] < lo[0]) lo = x; if (x[0] > hi[0]) hi = x; }
  return lo[1] === hi[1] ? lo[1] : `${lo[1]}~${hi[1]}`;
}
